// ========================================
// 📄 src/hooks/useLeads.js
// ========================================
import { useState, useEffect } from "react";
import { leadService } from "../services/leadService";
import { useAuth } from "../contexts/AuthContext";

export const useLeads = () => {
  const { currentUser, isAdmin } = useAuth();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadLeads = async () => {
    try {
      setLoading(true);
      const data = isAdmin
        ? await leadService.getAllLeads()
        : await leadService.getLeadsByUser(currentUser.uid);
      setLeads(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentUser) {
      loadLeads();
    }
  }, [currentUser, isAdmin]);

  return { leads, loading, error, refetch: loadLeads };
};
